<div class="m-3 my-4 flex grid">
  <div class="col align-items-left flex-grow-1 p-0">
    <div class="text-3xl pb-1 font-semibold">{{ header }}</div>
    <div class="text-xs font-semibold">{{ navigationPath }}</div>
  </div>
  <div class="col p-0">
    <ng-content></ng-content>
  </div>
</div>
